import { Link } from "react-router-dom";
import { ArrowRight, ClipboardList, Home as HomeIcon, Users, ShieldCheck, Printer } from "lucide-react";
import { FAMILY_SURVEY_URL } from "@/data/links";

const POINTS = [
  { icon: HomeIcon, t: "One form per household" },
  { icon: Users, t: "Helps your GKK serve you better" },
  { icon: ShieldCheck, t: "Kept private by the Parish" },
];

export default function FamilySurveyBanner() {
  return (
    <section id="family-survey" data-testid="family-survey-banner" className="bg-parchment-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="relative overflow-hidden bg-sage-dark text-parchment-100 grid lg:grid-cols-12">
          <div className="absolute -left-10 -bottom-16 font-serif text-[16rem] leading-none text-parchment-100/[0.06] select-none">✠</div>
          <div className="relative lg:col-span-8 p-10 md:p-14">
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-gold mb-5">
              <ClipboardList size={15} /> Parish Family Survey
            </div>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.1]">
              Every family counts in the <span className="italic text-gold">household of God.</span>
            </h2>
            <p className="mt-5 max-w-2xl font-sans font-light text-parchment-100/85 leading-relaxed">
              Help us know and care for every family of Saint Francis of Assisi Parish. The survey takes only a few minutes and guides how our GKKs, ministries, and outreach serve you.
            </p>
            <ul className="mt-8 flex flex-wrap gap-x-8 gap-y-3">
              {POINTS.map(({ icon: Icon, t }) => (
                <li key={t} className="flex items-center gap-2 text-sm font-sans text-parchment-100/90">
                  <Icon size={15} className="text-gold" /> {t}
                </li>
              ))}
            </ul>
          </div>
          <div className="relative lg:col-span-4 flex flex-col items-start lg:items-center justify-center p-10 pt-0 lg:pt-10 lg:border-l border-parchment-100/15">
            <a
              href={FAMILY_SURVEY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="family-survey-start-btn"
              className="group inline-flex items-center gap-3 rounded-full bg-gold text-cocoa-900 px-9 py-4 font-sans text-sm uppercase tracking-[0.2em] hover:bg-parchment-100 transition-colors duration-300"
            >
              Start the Survey
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <Link
              to="/survey-poster"
              data-testid="family-survey-poster-link"
              className="mt-4 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-parchment-100/80 hover:text-gold transition-colors font-sans"
            >
              <Printer size={13} /> Print a poster for your chapel
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
